/**
 * Logikk for Work Environment Score System
 * Implementerer 9 dimensjoner og vektet gjennomsnittsberegning.
 */

export const scoreDimensions = [
  { id: 'leadership', name: 'Ledelse', icon: 'Award', color: 'indigo' },
  { id: 'roleClarity', name: 'Rolleklarhet', icon: 'Target', color: 'violet' },
  { id: 'collaboration', name: 'Samarbeid', icon: 'Users', color: 'blue' },
  { id: 'psychSafety', name: 'Psykologisk Trygghet', icon: 'Shield', color: 'emerald' },
  { id: 'workload', name: 'Arbeidsbelastning', icon: 'Wind', color: 'rose' },
  { id: 'stress', name: 'Stressmestring', icon: 'Zap', color: 'orange' },
  { id: 'conflict', name: 'Konfliktklima', icon: 'AlertTriangle', color: 'amber' },
  { id: 'culture', name: 'Organisasjonskultur', icon: 'Globe', color: 'cyan' },
  { id: 'engagement', name: 'Medarbeiderengasjement', icon: 'Heart', color: 'pink' }
];

export const getScoreLevel = (score) => {
  if (score >= 80) return { label: 'Strong Work Environment', color: 'emerald', status: 'Excellence' };
  if (score >= 60) return { label: 'Moderate Work Environment', color: 'indigo', status: 'Stable' };
  if (score >= 40) return { label: 'Weak Work Environment', color: 'amber', status: 'Warning' };
  return { label: 'Critical Work Environment Risk', color: 'rose', status: 'Critical' };
};

export const calculateTotalScore = (scores) => {
  const values = Object.values(scores);
  if (values.length === 0) return 0;
  const sum = values.reduce((a, b) => a + b, 0);
  return Math.round(sum / scoreDimensions.length);
};

export const getRecommendations = (scores) => {
  const recommendations = [];
  
  if (scores.leadership < 50) {
    recommendations.push({
      title: "Lederstøtte-program",
      desc: "Lav score på ledelse indikerer behov for operativ lederstøtte og tettere oppfølging av mellomledere.",
      priority: 'Høy'
    });
  }
  
  if (scores.stress < 40 || scores.workload < 40) {
    recommendations.push({
      title: "Risikovurdering: Belastning",
      desc: "Kritisk nivå på stress/arbeidsmengde krever umiddelbar gjennomgang av ressurser og prioriteringer.",
      priority: 'Kritisk'
    });
  }

  if (scores.psychSafety < 50) {
    recommendations.push({
      title: "Kulturverksted: Trygghet",
      desc: "Teamet viser tegn til taushetskultur. Anbefaler workshop for å bygge psykologisk trygghet.",
      priority: 'Medium'
    });
  }

  return recommendations;
};